module.exports = __webpack_public_path__ + "img/ico-rect-blue.7c0dac9d.svg";